import { ca } from '@cian/analytics';

export const trackApplyDatesModal = () => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'DailyrentCalendar',
    label: 'ConfirmDates',
  });
};

export function trackSearchButtonClick(label: string) {
  ca('event', {
    name: 'oldevent',
    category: 'FastFilters',
    action: 'click',
    label,
  });
}
